import React from 'react';
import { Link } from 'react-router-dom';
import { Activity } from '../types';
import { formatDate } from '../utils/dateFormat';

interface ActivitiesTableProps {
  activities: Activity[];
  onEdit: (activity: Activity) => void;
  onDelete: (activityId: number) => void;
  onViewDetails?: (activityId: number) => void; // опційно
}

const ActivitiesTable: React.FC<ActivitiesTableProps> = ({
  activities,
  onEdit,
  onDelete,
  onViewDetails,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <colgroup>
          <col style={{ width: '45%' }} />
          <col style={{ width: '35%' }} />
          <col style={{ width: '20%' }} />
        </colgroup>
        <thead className="table-light">
          <tr>
            <th className="text-start">Title</th>
            <th className="text-start">Created Date</th>
            <th className="text-start">Actions</th>
          </tr>
        </thead>
        <tbody>
          {activities.map(activity => (
            <tr key={activity.id}>
              <td>{activity.title}</td>
              <td>{formatDate(activity.createdDate)}</td>
              <td className="text-start">
                <div className="btn-group action-group" role="group">
                  {onViewDetails && (
                    <button
                      className="btn action-btn action-view"
                      onClick={() => onViewDetails(activity.id)}
                      title="View Details"
                    >
                      <i className="fa-solid fa-eye" aria-hidden="true" />
                    </button>
                  )}
                  <button
                    className="btn action-btn action-edit"
                    onClick={() => onEdit(activity)}
                    title="Edit"
                  >
                    <i className="fa-solid fa-pen" aria-hidden="true" />
                  </button>
                  <button
                    className="btn action-btn action-delete"
                    onClick={() => onDelete(activity.id)}
                    title="Delete"
                  >
                    <i className="fa-solid fa-trash" aria-hidden="true" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ActivitiesTable;
